<template>
  <div class="gap-4 p-4 flex flex-col">
    <ExercisesResultsHistoryListItem
      v-for="(historyItem, index) of list"
      :key="index"
      :history-item="historyItem"
      :index="index"
    />
  </div>
</template>

<script>
import ExercisesResultsHistoryListItem from '@/components/Hub/Exercises/ExercisesResultsHistoryListItem.vue'

export default {
  name: 'HubExercisesResultsHistory',

  components: { ExercisesResultsHistoryListItem },

  props: {
    list: { type: Array, default: () => [] }
  }
}
</script>
